// import ApiProfile from "@/api/profile"
import _ from 'lodash'
import ApiGroup from "@/api/group";

export default {
    namespaced: true,

    state: {
        user: [],
        groupList: [],
        zoneList: [],
    },

    getters: {
        user: (state) => state.user,
        groupList: (state) => state.groupList,
        zoneList: (state) => state.zoneList,
    },

    mutations: {
        SET_USER(state, user) {
            state.user = user
        },
        SET_GROUP_LIST(state, groupList) {
            state.groupList = groupList
        },
        SET_ZONE_LIST(state, zoneList) {
            state.zoneList = zoneList
        },
    },

    actions: {
        setUser({ commit }, data) {
            commit("SET_USER", data)
        },
        getGroupList({ commit }) {
            ApiGroup.getGroupList().then((responce) => {
                console.log(responce);
                commit("SET_GROUP_LIST", responce.data)

            })

        },
        getZoneList({ commit }) {
            console.log('zone2'); 
            ApiGroup.getZoneList().then((responce) => {
                console.log('zone', responce);
                commit("SET_ZONE_LIST", responce.data)

            })

        }
    }
}